import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { fetchCategories } from "actions/marketplaceActions";
import CategoryItem from "./CategoryItem";
import messages from "components/messagesDescription";

const Categories = ({ fetchCategories, categories, intl }) => {
  useEffect(() => {
    fetchCategories();
  }, []);
  return (
    <div className="category-list-container">
      <strong>
        <u style={{ marginLeft: "10px" }}>
          {intl.formatMessage(messages.marketplace.categoriesLabel)}:
        </u>
      </strong>
      <div className="card-container">
        {categories.map(item => {
          return <CategoryItem key={item.tagId} category={item} />;
        })}
      </div>
    </div>
  );
};

Categories.propTypes = {
  categories: PropTypes.array.isRequired,
  fetchCategories: PropTypes.func.isRequired,
  intl: PropTypes.object,
};

const mapStateToProps = ({ marketplace }) => {
  const { categories } = marketplace;
  return {
    categories,
  };
};

const mapDispatchToProps = {
  fetchCategories,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Categories));



// WEBPACK FOOTER //
// ./components/marketplace/CategoryList.jsx